module.exports = __webpack_public_path__ + "static/media/Collections-Wedding-Desktop.29b55a05.webp";